const INIT_STATE = {
    data: [],
    roomExpiredBackup: []
};

export default function historyReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case "TEXT_RECEIVER":
        case "KEYBOARD_RECEIVER":
        case "PICTURE_RECEIVER":
        case "CAROUSEL_RECEIVER":
        case "FILE_RECEIVER":
        case "URL_RECEIVER":
            return {
                ...state,
                data: [...state.data, {receiver: action.payload}]
            };
        case "KEYBOARD_SENDER":
        case "TEXT_SENDER":
        case "CAROUSEL_SENDER":
            return {
                ...state,
                data: [...state.data, {sender: action.payload}]
            };
        case "ROOM_EXPIRED_BACKUP":
            return {
                ...state,
                roomExpiredBackup: [...action.payload]
            };
        case "BACKUP_HISTORY_MESSAGES":
            return {
                ...state,
                data: state.roomExpiredBackup,
                roomExpiredBackup: []
            };
        case "SET_HISTORY": {
            return {
                ...state,
                data: action.payload && action.payload.filter(el => !(el.sender && el.sender.type === "EVENT")).reduce((prev, next) => {
                    if (next.sender && next.sender.type === "COMMAND") {
                        let receiver = prev[prev.length - 1].receiver;
                        if (receiver && receiver.type === "KEYBOARD") {
                            next = {
                                sender: receiver.buttons
                                    .map(el => el.payload)
                                    .find(el => el.id === next.sender.id)
                            }
                        } else if (receiver && receiver.type === "CAROUSEL") {
                            next = {
                                sender: receiver.cards
                                    .map(el => el.payload)
                                    .find(el => el && el.altText === next.sender.id)
                            }
                        } else {
                            next = {
                                sender: {type: "TEXT", text: receiver && receiver.text ? receiver.text : ''}
                            }
                        }
                    }
                    return prev.concat(next);
                }, [])
            }
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/historyReducer.js